import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../..";

export const userSelector = createSelector(
  (state: RootState) => state.authState,
  (state) => state.loggedUser,
);

export const isAuthenticatedSelector = createSelector(
  (state: RootState) => state.authState,
  (state) => Boolean(Object.keys(state.loggedUser ?? {})?.length),
);

export const tokenSelector = createSelector(
  (state: RootState) => state.authState,
  (state) => state.token,
);

export const clientIDSelector = createSelector(
  (state: RootState) => state.authState,
  (state) => state.loggedUser?.client,
);

export const clientDataSelector = createSelector(
  (state: RootState) => state.authState,
  (state) => state.clientData,
);

export const userSurveysIdsSelector = createSelector(
  (state: RootState) => state.authState,
  (state) => state.clientData?.surveyInfo.map((survey) => survey.survey_id),
);

export const userSurveysSelector = createSelector(
  (state: RootState) => state.authState,
  (state) => state.clientData?.surveyInfo,
);

export const isLoadingClientDataSelector = createSelector(
  (state: RootState) => state.authState,
  (state) => state.isLoadingClientData,
);

export const authStateSelectors = {
  userLogged: userSelector,
  userIsLogged: isAuthenticatedSelector,
  token: tokenSelector,
  clientID: clientIDSelector,
  clientData: clientDataSelector,
  userSurveysIds: userSurveysIdsSelector,
  userSurveys: userSurveysSelector,
  isLoadingClientData: isLoadingClientDataSelector,
};
